/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCEditModal = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
      <Dialog open={showEditModal} onOpenChange={setShowEditModal}>
        <DialogContent className="max-w-lg" data-testid="credits-edit-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="w-5 h-5 text-amber-600" />
              Modifier les crédits
            </DialogTitle>
            {editTarget && (
              <DialogDescription>
                {editTarget.user_info?.prenom} {editTarget.user_info?.nom} — {editTarget.user_info?.email}
              </DialogDescription>
            )}
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Standard</Label>
                <Input
                  type="number"
                  value={editForm.credits_standard}
                  onChange={(e) => setEditForm({ ...editForm, credits_standard: parseInt(e.target.value || '0', 10) })}
                  data-testid="credits-edit-standard"
                />
              </div>
              <div>
                <Label>Prioritaire</Label>
                <Input
                  type="number"
                  value={editForm.credits_prioritaires}
                  onChange={(e) => setEditForm({ ...editForm, credits_prioritaires: parseInt(e.target.value || '0', 10) })}
                  data-testid="credits-edit-prioritaire"
                />
              </div>
              <div>
                <Label>Bonus</Label>
                <Input
                  type="number"
                  value={editForm.credits_bonus}
                  onChange={(e) => setEditForm({ ...editForm, credits_bonus: parseInt(e.target.value || '0', 10) })}
                  data-testid="credits-edit-bonus"
                />
              </div>
              <div>
                <Label>Temporaire</Label>
                <Input
                  type="number"
                  value={editForm.credits_temporaires}
                  onChange={(e) => setEditForm({ ...editForm, credits_temporaires: parseInt(e.target.value || '0', 10) })}
                  data-testid="credits-edit-temporaire"
                />
              </div>
            </div>
            {editForm.credits_temporaires > 0 && (
              <div>
                <Label>Durée de validité des crédits temporaires (jours)</Label>
                <Input
                  type="number"
                  placeholder="Laisser vide pour ne pas changer"
                  value={editForm.duree_validite_jours || ''}
                  onChange={(e) => setEditForm({ ...editForm, duree_validite_jours: e.target.value ? parseInt(e.target.value, 10) : null })}
                  data-testid="credits-edit-duree"
                />
              </div>
            )}
            <div>
              <Label>Raison *</Label>
              <Textarea
                value={editForm.raison}
                onChange={(e) => setEditForm({ ...editForm, raison: e.target.value })}
                placeholder="Motif de la modification (audit log)…"
                data-testid="credits-edit-raison"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditModal(false)}>Annuler</Button>
            <Button onClick={handleSaveEdit} className="bg-amber-600 hover:bg-amber-700" data-testid="credits-edit-save">
              <Edit className="w-4 h-4 mr-2" />
              Enregistrer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default GCEditModal;
